import { Doc } from '@dadohr/shared/domainTypes/document';
import { EMPTY_OBJ } from '@dadohr/shared/domainTypes/emptyConstants';
import { IMomentTemplate } from '@dadohr/shared/domainTypes/experience';
import { IMomentMail } from '@dadohr/shared/domainTypes/mail';
import { IOrganization } from '@dadohr/shared/domainTypes/org';
import { IUser } from '@dadohr/shared/domainTypes/user';
import { useMemo } from 'react';
import { useUnsafeTranslation } from '../../../../../../i18next';
import { useCurrentUser } from '../../../../../../services/currentUser';
import { sendPreviewMail } from '../../../../../../services/mail';
import { now } from '../../../../../../services/time';
import { toFullName } from '../../../../../../services/user';
import { SendTestButton } from '../../../../../Experiences/pages/Details/SendTest';
import {
  createDenormalizedMomentForPreviewing,
  getMomentsAudience
} from '../../../../services';

export const SendMomentTestButton = ({
  d,
  org
}: {
  d: Doc<IMomentTemplate>;
  org: IOrganization;
}) => {
  const { t } = useUnsafeTranslation();
  const currentUser = useCurrentUser();
  // this needs to be done better - probably pass in from the
  const senderName = toFullName(currentUser);
  const { sendMail } = useMemo(() => {
    const toParams = (sampleUser: Doc<IUser>): IMomentMail => {
      return {
        type: 'MOMENT',
        props: {
          orgId: d.data.orgId,
          moment: createDenormalizedMomentForPreviewing(
            org,
            d,
            sampleUser,
            d.data.sendDate.at
          ),
          preview: {
            sender: {
              name: senderName
            },
            isPreview: true
          }
        }
      };
    };

    return {
      sendMail: async (sampleUser: Doc<IUser>, recipientEmail: string) => {
        const params = toParams(sampleUser);
        const mail = await sendPreviewMail(params, { email: recipientEmail });
        return mail;
      }
    };
  }, [d, org, senderName]);
  return (
    <SendTestButton
      orgId={d.data.orgId}
      recipientActors={EMPTY_OBJ}
      sendMail={sendMail}
      sendSlack={undefined}
      validateParticipant={(user) => {
        if (!getMomentsAudience(d, user, now())) {
          return `${t(
            `This {{ type }} does not apply for {{ name}}'s Target Audience. Please select a different participant.`,
            {
              type: t('Moment'),
              name: toFullName(user.data)
            }
          )}`;
        }
        return null;
      }}
    />
  );
};
